import { PATHNAMES } from 'utils/routes/consts'

export const ZAI_NATIVE_SIDE_CHAT_OPEN_EVENT = 'zai-native-side-chat:open'
export const ZAI_NATIVE_SIDE_CHAT_TOGGLE_EVENT = 'zai-native-side-chat:toggle'

export const ZAI_PAGES_EXCEPTION = [
  {
    path: PATHNAMES.ZAI,
    exact: true,
  },
  {
    path: PATHNAMES.WORKSPACE_ZAI,
    exact: true,
  },
  {
    path: PATHNAMES.SOA,
    exact: true,
  },
  {
    path: PATHNAMES.WORKSPACE_SOA,
    exact: true,
  },
  {
    path: PATHNAMES.INDUSTRY_CATEGORY_DEMAND_INTELLIGENCE,
    exact: true,
  },
] as const
